import { Link } from '@/components/Link';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { KeesingGames } from 'base/components/KeesingGames/KeesingGames';
import { getOcelotConfig } from 'lib/configs/ocelot';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { useSearchParam } from 'react-use';

export interface StandaloneKeesingGamesProps extends StandaloneComponentProps<typeof KeesingGames> {}

export const StandaloneKeesingGames: StandaloneComponent<StandaloneKeesingGamesProps> = ({ ...props }) => {
  const { enabled, customerId, scriptPath, stylesPath, frontPagePathname, games } =
    getOcelotConfig('features.keesingGames');
  const hasGametypeParam = Boolean(useSearchParam('gametype'));
  const { asPath } = useRouter();

  const pathname = asPath.split('?')[0];
  const segments = pathname.startsWith(frontPagePathname + '/')
    ? pathname.slice(frontPagePathname.length + 1).split('/')
    : [];
  const slug = segments.length > 0 ? segments[segments.length - 1].toLowerCase() : null;

  const gameFromSlug = !hasGametypeParam && slug ? (games.find((g) => g.slug === slug) ?? null) : null;
  const isPlaying = hasGametypeParam || Boolean(gameFromSlug);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!enabled || !customerId || !scriptPath) return null;

  return (
    <>
      <Head>
        <link rel="stylesheet" href={stylesPath} />
      </Head>
      <KeesingGames {...props}>
        {isClient && isPlaying && (
          <Link
            href={frontPagePathname}
            content={
              <KeesingGames.LinkText>
                <KeesingGames.Icon name="chevronLeft" />
                Gå tillbaka till alla spel
              </KeesingGames.LinkText>
            }
          />
        )}
        <KeesingGames.PuzzlePortal
          data-playerpath={frontPagePathname}
          data-customerid={customerId}
          {...(gameFromSlug && {
            'data-gametype': gameFromSlug.gameType,
            'data-puzzleid': gameFromSlug.puzzleId,
            ...(gameFromSlug.requiresLogin && { 'data-login': 'true' }),
          })}
          id="puzzle-portal"
        />
        <Script type="text/javascript" src={scriptPath} data-wlpp-bundle={isPlaying ? 'player' : 'portal'} />
      </KeesingGames>
    </>
  );
};
